// 文字汇总
<template>
  <div v-if="taskItemData.txtTotal" style="padding-bottom: 20px; text-align: left; font-size: 12pt; font-family: 宋体">
    {{ taskItemData.txtTotal }}
  </div>
</template>

<script>
export default {
  name:'TextChart',
  components: {},
  props: ['taskItemData', 'showBtn'],
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped></style>
